import { Col, Row } from 'antd';

import ImageComponent from '@sharedComponent/image-component';
import React from 'react';

function MobileFilter(
	{ atmsC, setAtmsC, rakbankAtm, setRakbankAtm, isFilter, setFilter, emiratesLocation, emiratesStates, setEmiratesStates },
	props
) {
	return (
		<>
			<Row className="atm-inputs-outer-mobile animation-fade">
				<Col xs={24} className="header-emir">
					<div className="label-check-text">Emirates:</div>
				</Col>

				<Col xs={10} className="mobile-par-checkbox">
					<div
						className="checkbox"
						id="checkbox"
						onClick={() => {
							// setEmiratesStates({ allEmirates: !emiratesStates.allEmirates });
							emiratesLocation('allemirates');
						}}>
						<div className="sub-checkbox-con">
							<div className="tick-icon">
								{emiratesStates.allEmirates ? <ImageComponent className="tick-enabled" /> : <ImageComponent className="tick" />}
							</div>
							<div className="label-check-mobile emirate-custom">All Emirates</div>
						</div>
					</div>
				</Col>
				<Col xs={14}></Col>
				<Col xs={10} className="mobile-par-checkbox">
					<div
						className="checkbox"
						id="checkbox"
						onClick={() => {
							setEmiratesStates({ abudhabi: !emiratesStates.abudhabi });
							emiratesLocation('abudhabi');
						}}>
						<div className="sub-checkbox-con">
							<div className="tick-icon">
								{emiratesStates.abudhabi ? <ImageComponent className="tick-enabled" /> : <ImageComponent className="tick" />}
							</div>
							<div className="label-check-mobile">Abu Dhabi</div>
						</div>
					</div>
				</Col>
				<Col xs={1}></Col>
				{/* Col xs={12} */}

				<Col xs={8} className="mobile-par-checkbox">
					<div
						className="checkbox"
						id="checkbox"
						onClick={() => {
							setEmiratesStates({ dubai: !emiratesStates.dubai });
							emiratesLocation('dubai');
						}}>
						<div className="sub-checkbox-con">
							<div className="tick-icon">
								{emiratesStates.dubai ? <ImageComponent className="tick-enabled" /> : <ImageComponent className="tick" />}
							</div>
							<div className="label-check-mobile">Dubai</div>
						</div>
					</div>
				</Col>
				<Col xs={5}></Col>
				{/* </div> */}
				<Col xs={8} className="mobile-par-checkbox">
					<div
						className="checkbox"
						id="checkbox"
						onClick={() => {
							setEmiratesStates({ sharjah: !emiratesStates.sharjah });
							emiratesLocation('sharjah');
						}}>
						<div className="sub-checkbox-con">
							<div className="tick-icon">
								{emiratesStates.sharjah ? <ImageComponent className="tick-enabled" /> : <ImageComponent className="tick" />}
							</div>
							<div className="label-check-mobile">Sharjah</div>
						</div>
					</div>
				</Col>
				<Col xs={1}></Col>
				<Col xs={8} className="mobile-par-checkbox">
					<div
						className="checkbox"
						id="checkbox"
						onClick={() => {
							setEmiratesStates({ ajman: !emiratesStates.ajman });
							emiratesLocation('ajman');
						}}>
						<div className="sub-checkbox-con">
							<div className="tick-icon">
								{emiratesStates.ajman ? <ImageComponent className="tick-enabled" /> : <ImageComponent className="tick" />}
							</div>
							<div className="label-check-mobile">Ajman</div>
						</div>
					</div>
				</Col>
				<Col xs={6}></Col>
				<Col xs={8} className="mobile-par-checkbox">
					<div
						className="checkbox"
						id="checkbox"
						onClick={() => {
							setEmiratesStates({ alain: !emiratesStates.alain });
							emiratesLocation('alain');
						}}>
						<div className="sub-checkbox-con">
							<div className="tick-icon">
								{emiratesStates.alain ? <ImageComponent className="tick-enabled" /> : <ImageComponent className="tick" />}
							</div>
							<div className="label-check-mobile">Al Ain</div>
						</div>
					</div>
				</Col>
				<Col xs={1}></Col>
				<Col xs={12} className="mobile-par-checkbox">
					<div
						className="checkbox"
						id="checkbox"
						onClick={() => {
							setEmiratesStates({ rasalkhaimah: !emiratesStates.rasalkhaimah });
							emiratesLocation('rasalkhaimah');
						}}>
						<div className="sub-checkbox-con">
							<div className="tick-icon">
								{emiratesStates.rasalkhaimah ? <ImageComponent className="tick-enabled" /> : <ImageComponent className="tick" />}
							</div>
							<div className="label-check-mobile">Ras AI Khaimah</div>
						</div>
					</div>
				</Col>
				<Col xs={3}></Col>
				<Col xs={9} className="mobile-par-checkbox">
					<div
						className="checkbox"
						id="checkbox"
						onClick={() => {
							setEmiratesStates({ fujairah: !emiratesStates.fujairah });
							emiratesLocation('fujairah');
						}}>
						<div className="sub-checkbox-con">
							<div className="tick-icon">
								{emiratesStates.fujairah ? <ImageComponent className="tick-enabled" /> : <ImageComponent className="tick" />}
							</div>
							<div className="label-check-mobile">Fujairah</div>
						</div>
					</div>
				</Col>

				<Col xs={24} className="header-emir">
					<div className="label-check-text">ATMs:</div>
				</Col>
				<Col xs={9} className="mobile-par-checkbox">
					<div className="checkbox" id="checkbox" onClick={() => setAtmsC(!atmsC)}>
						<div className="sub-checkbox-con">
							<div className="tick-icon">
								{atmsC ? <ImageComponent className="tick-enabled" /> : <ImageComponent className="tick" />}
							</div>
							<div className="label-check-mobile">C3 ATMs</div>
						</div>
					</div>
				</Col>
				<Col xs={1}></Col>
				<Col xl={4} lg={4} md={4} sm={4} xs={13} className="mobile-par-checkbox">
					<div className="checkbox" id="checkbox" onClick={() => setRakbankAtm(!rakbankAtm)}>
						<div className="sub-checkbox-con">
							<div className="tick-icon">
								{rakbankAtm ? <ImageComponent className="tick-enabled" /> : <ImageComponent className="tick" />}
							</div>
							<div className="label-check-mobile">RAKBANK ATMs</div>
						</div>
					</div>
				</Col>
				<Col xs={1}></Col>
				<div className="apply-btn-main">
					<button className="map-btn" onClick={() => setFilter(!isFilter)} style={{ width: '136px', height: '28px' }}>
						APPLY
					</button>
				</div>
			</Row>
		</>
	);
}

export default MobileFilter;
